/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/spaManager/reactManager" />
import * as React from 'react';
import * as ko from 'knockout';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { create } from 'Core/Medius.Core.Web/Scripts/Medius/apps/spaManager/manager';

interface ReactAppManagerProps {
    containerId: string;
    appsContainerId: string;
    canToggleNewInbox: boolean;
    isNewInboxEnabled: boolean;
}

const ReactAppManager = (
    {containerId, appsContainerId, canToggleNewInbox, isNewInboxEnabled} : ReactAppManagerProps
) => {
    useEffect(() => {
        const appManager = create(containerId, appsContainerId, canToggleNewInbox, isNewInboxEnabled);
        ko.applyBindings(appManager, document.getElementById(containerId));
        appManager.start();
        require("inbox").init();

        return () => {
            ko.cleanNode(document.getElementById(containerId));
        };
    }, [containerId, appsContainerId, canToggleNewInbox, isNewInboxEnabled]);

    return (<>
        <div id={appsContainerId} className="clearfix"></div>
    </>);
};

export const init = (
    containerId: string,
    appsContainerId: string,
    canToggleNewInbox: boolean,
    isNewInboxEnabled: boolean
) => {
    const container = document.getElementById(containerId);

    if (container) {
        const root = createRoot(container!);
        root.render(
            <ReactAppManager
                containerId={containerId}
                appsContainerId={appsContainerId}
                canToggleNewInbox={canToggleNewInbox}
                isNewInboxEnabled={isNewInboxEnabled}
            />
        );
    }
};